import DomCreate from "./utils/domCreate.js";

export default class StyledNumberInput {
    options = {
        selector: '.styled-number-input',
        controlSelector: '.control',
        inputSelector: 'input[type=number].input',
    };

    constructor(userOptions = {}) {
        for (const prop in userOptions) {
            if (Object.prototype.hasOwnProperty.call(this.options, prop)) {
                this.options[prop] = userOptions[prop];
            }
        }

        this.initSelectors(document);
    }

    initSelectors(rootElement) {
        const elements = rootElement.querySelectorAll(this.options.selector);
        elements.forEach(element => {
            this.initElement(element);
        });
    }

    initElement(element) {
        if (element.hasOwnProperty('moduleStyledNumberInputInitialized')) { return; }
        element.moduleStyledNumberInputInitialized = true;
        element.classList.add('initialized');

        const inputElement = element.querySelector(this.options.inputSelector);
        if (!inputElement) { return; }
        const controlElement = element.querySelector(this.options.controlSelector);
        if (!controlElement) { return; }

        const step = inputElement.dataset.step ? parseFloat(inputElement.dataset.step) : inputElement.getAttribute('step') ? parseFloat(inputElement.getAttribute('step')) : 1;

        controlElement.insertBefore(this.createControlButton(true, step), null);
        controlElement.insertBefore(this.createControlButton(false, step), null);

        inputElement.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowUp') {
                e.preventDefault();
                e.stopPropagation();
                inputElement.value = (parseFloat(inputElement.value) || 0) + step;
            }
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                e.stopPropagation();
                inputElement.value = (parseFloat(inputElement.value) || 0) - step;
            }
        });

        this.initPresets(controlElement, inputElement);
    }

    createControlButton(add, step) {
        const button = DomCreate.create('button', ['button', 'control-button', add?'is-left':'is-right'], {tabindex: '-1', type: 'button'});
        button.innerHTML = (add?'+':'-')+step;
        button.addEventListener('mousedown', (e) => {
            e.preventDefault();
            const inputElement = e.target.parentElement.querySelector(this.options.inputSelector);
            if (!inputElement) { return; }
            inputElement.focus();
        });
        button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const inputElement = e.target.parentElement.querySelector(this.options.inputSelector);
            if (!inputElement) { return; }
            if (add) {
                inputElement.value = (parseFloat(inputElement.value) || 0) + step;
            }else{
                inputElement.value = (parseFloat(inputElement.value) || 0) - step;
            }
        });
        return button;
    }

    initPresets(element, inputElement) {
        const presets = inputElement.dataset.presets ? JSON.parse(inputElement.dataset.presets) : [];
        if (presets.length === 0) { return; }
        const presetContainer = DomCreate.create('div', ['presets']);
        presets.forEach(preset => {
            const button = DomCreate.create('button', ['button', 'is-small'], {tabindex: '-1', type: 'button'});
            button.innerHTML = preset[1];
            button.addEventListener('mousedown', (e) => {
                e.preventDefault();
                inputElement.focus();
            });
            button.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                inputElement.value = preset[0];
            });
            presetContainer.insertBefore(button, null);
        });
        element.insertBefore(presetContainer, null);
    }
}